import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router"

import ChilMNodalEdit from "../childModalEdit/childModalEdit";
import { useToast } from '@chakra-ui/react'
import PerfomerEdit from "../perfomerEdit/perfomerEdit";
import DropdownMobilePioritet from "../tableTask/editPrioritetForMobile/editPrioritetForMobile";
import Prioritet from "../prioritet/prioritet";
import DropdownMobileStatus from "../tableTask/EditStatusForMobile/editStatusForMobile";
import Status from "../status/status";
import MetkaEdit from "../metka/metka";
import UploadFileTaskMenegerEditChilds from "../uploadFile/uploadFileChildEdit";
import CommentBox from "../commentBox/commentBox";
import sockets from "../../../../socket/socket";
const socket = sockets

export default function EditChild() {

    const [item, setItem] = useState(null)
    let getCompanyID = useSelector(compID => compID.checkedSessionReducer)
    let getmyinfo = useSelector(compID => compID.getMayInfoReducer)
    const [adminInfo, setadminInfo] = useState("")
    const [load, setload] = useState(false)
    const [loadBTN, setloadloadBTN] = useState(false)
    const toast = useToast()
    let { id, index } = useParams();

    useEffect(() => {
        axios
          .post('/findTaskByUrl', {
            taskID: id
          })
          .then(function (response) {
            setItem(response.data.data);
            setadminInfo(response.data.adminIfno);
            console.log(response.data.data, "itemaaaaaaaaaaaaaaaaaaaaa"); // Log 'item' after it has been set
          })
          .catch(function (error) {
            console.log(error);
          });
      }, []);
      


      function update(params) {
        socket.emit('getallTaskforUpdateServer', { room:getCompanyID.checkedSession});
      }

    useEffect(() => {


        // update all task for my data
        socket.on('getAllTaskANDupdate', () => {

            setload(true)
            console.log("UPDATEtASK");


            axios.post('/findTaskByUrl', {
                taskID: id
            })
                .then(function (response) {
                    console.log(response.data.data, "getCurrentData");
                    setItem(response.data.data)
                })
                .catch(function (error) {
                    console.log(error);
                });

        });


        return () => {

            socket.off('getAllTaskANDupdate');

        };
    }, []);

    const handleGetNotify = () => {
        socket.emit('getNotifyEmit');
    }

    const sendServer = () => {
            
    }
    const handleClose = () => { }


    const [comments, setComments] = useState([]);

    const currentDate = new Date();
    const adjustedDate = new Date(currentDate.getTime() - currentDate.getTimezoneOffset() * 60000);
    const formattedDate = adjustedDate.toISOString().slice(0, 16);
    const [startDate, setStartDate] = useState(formattedDate);
    const [endDate, setEndDate] = useState(formattedDate);
    const [status, setStatus] = useState("Запланирована");
    const [prioritet, setPrioritet] = useState("Низший");
    const [metka, setMetka] = useState([]);
    const [performer, setperformer] = useState("");
    const [aboutTask, setAboutTask] = useState("");
    const [file, setfile] = useState("");
    const [perfomerID, setperfomerID] = useState([]);
    const [endDateConfirm, setDndDateConfirm] = useState("");
    const [allitem, setAllitem] = useState()
    const [editAllTask, seteditAllTask] = useState()
    const [nameCurrentSubTask, setnameCurrentSubTask] = useState("")
    const getDarkModoe = useSelector(darkModes => darkModes)
    const modalRef = useRef(null);


    const deleteItemByIndex = () => { }




    useEffect(()=>{
   
            
        setComments(item?.alltask[0]?.child[index]?.comments)
        setStartDate(item?.alltask[0]?.child[index]?.startDate)
        setEndDate(item?.alltask[0]?.child[index]?.endDate)
        setAboutTask(item?.alltask[0]?.child[index]?.aboutTask)
        setPrioritet(item?.alltask[0]?.child[index]?.prioritet)
        setStatus(item?.alltask[0].child[index]?.status)
        setperformer(item?.alltask[0]?.child[index]?.performer)
        setfile(item?.alltask[0]?.child[index]?.file)
        setMetka(item?.alltask[0]?.child[index]?.metka)
   
      
},[item?.alltask[0]?.child[index]?.comments,item?.alltask[0]?.child[index]?.startDate,item?.alltask[0]?.child[index]?.endDate,item?.alltask[0]?.child[index]?.aboutTask,item?.alltask[0]?.child[index]?.prioritet,item?.alltask[0]?.child[index]?.status,item?.alltask[0]?.child[index]?.performer,item?.alltask[0]?.child[index]?.file,item?.alltask[0]?.child[index]?.metka])


    //     setComments(item?.alltask[0].child[index].comments)
    //     setStartDate(item?.alltask[0].child[index].startDate)
    //     setEndDate(item?.alltask[0].child[index].endDate)
    //     setAboutTask(item?.alltask[0].child[index].aboutTask)
    //     setPrioritet(item?.alltask[0].child[index].prioritet)
    //     setStatus(item?.alltask[0].child[index].status)
    //     setperformer(item?.alltask[0].child[index].performer)
    //     setfile(item?.alltask[0].child[index].file)
    //     setMetka(item?.alltask[0].child[index].metka)


    // }, [item?.alltask[0].child[index].comments, item?.alltask[0].child[index].startDate, item?.alltask[0].child[index].endDate, item?.alltask[0].child[index].aboutTask, item?.alltask[0].child[index].prioritet, item?.alltask[0].child[index].status, item?.alltask[0].child[index].performer, item?.alltask[0].child[index].file, item?.alltask[0].child[index].metka])







    // добавляет состояние и отправлять на сервер

    const sendserver = async() => {
    await  sendSeverCreatNotifyForTask();
        setloadloadBTN(true)
        item.alltask[0].child[index].comments = comments
        item.alltask[0].child[index].performer = performer
        item.alltask[0].child[index].startDate = startDate
        item.alltask[0].child[index].endDate = endDate
        item.alltask[0].child[index].status = status
        item.alltask[0].child[index].prioritet = prioritet
        item.alltask[0].child[index].aboutTask = aboutTask
        item.alltask[0].child[index].file = file
        item.alltask[0].child[index].metka = metka
        console.log(performer);
        if (performer.email) {
            console.log(performer.email);
            axios.post('/sendEmail/api', {
                perfomerEmail: performer.email
            })
                .then(function (response) {
                    console.log(response);
                })
                .catch(function (error) {
                    console.log(error);
                });
        }

        item.perfomerID = perfomerID
        item.allmetka = metka
    
      
        axios.post('/findAndUpdateTask', {
          itemID:item._id,
          currentTask:item.alltask,
          item,
          perfomerID: item.alltask[0],
          allmetka: metka,
          creaTorTask:item.creatorTasks,
          isLooping:item.isLooping,
          selectDays:item.selectDays,
          loopingStartDate:item.loopingStartDate,
          everythreedays:item.everythreedays
        })
          .then(function (response) {
            console.log(response);
            update()
   
            handleClose()
            setloadloadBTN(false)
    
          })
          .catch(function (error) {
            console.log(error);
            setload(false)
          });
    
        // sendServer()
        // handleClose()
        // handleCloseChild()
    }

    // обрабатывать добавить исполнителя 
    const HandleSetPerfomerId = (e) => {

        setperfomerID([e])
        setperformer(e)
        item.performer = performer
    }

    // обработать удалить Исполнитель 
    const HandleDeletePerfomerId = (e) => {
        setperformer("")
        setperfomerID([])
        item.performer = performer
    }
    // этот функция отправляет для подтверждения дату

    const handleDate = () => {

        axios.post('/notifyConfirm', {
            eidtTaskID: item._id,
            isChild: true,
            adminIDTask: item.creatorTasks.toString(),
            typenotify: "date",
            indexTask: index,
            senderName: getmyinfo.myinfo.name,
            senderTel: getmyinfo.myinfo.tel,
            senderEmail: getmyinfo.myinfo.email,
            text: "",
            messageConfirm: endDateConfirm,
            taskName: nameCurrentSubTask,
            oldDate: item.alltask[0].child[index].endDate

        })
            .then(function (response) {
                console.log(response);
                handleGetNotify()
                toast({
                    position: "top",
                    title: 'Отправлено на подтверждение постановщику задачи',
                    description: "Отправлено на подтверждение постановщику задачи",
                    status: 'success',
                    duration: 9000,
                    isClosable: true,
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    // этот функция отправляет для подтверждения статус 
    const handleStatus = () => {
        axios.post('/notifyConfirm', {
            eidtTaskID: item._id,
            isChild: true,
            adminIDTask: item.creatorTasks.toString(),
            typenotify: "status",
            indexTask: index,
            senderName: getmyinfo.myinfo.name,
            senderTel: getmyinfo.myinfo.tel,
            senderEmail: getmyinfo.myinfo.email,
            text: "",
            messageConfirm: endDate,
            taskName: nameCurrentSubTask,
            oldDate: item.alltask[0].child[index].endDate

        })
            .then(function (response) {
                console.log(response);
                handleGetNotify()
                toast({
                    position: "top",
                    title: 'Отправлено на подтверждение постановщику задачи',
                    description: "Отправлено на подтверждение постановщику задачи",
                    status: 'success',
                    duration: 9000,
                    isClosable: true,
                })
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    // обрабатывать файл изменений
    const handleChangeFile = (e) => {

        setfile(e)
      
    }


async function sendSeverCreatNotifyForTask(e) {
  const taskID = await axios.get(`/findTaskById/api?taskID=${item._id}`);
 
          if (taskID.data.data) {
            if (new Date(taskID.data.data.alltask[0].child[index].endDate).getTime() != new Date(endDate).getTime()) {
              if (item.alltask[0].performer) {
                // получаем информацию о пользователе
                const userInfo = await axios.get(`/getuserByID/api?userID=${item.creatorTasks}`);
                let mount = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"];
                const covertDate = new Date(endDate).getDay() + " "+ mount[new Date(endDate).getMonth()] + " " + new Date(endDate).getFullYear()
                let notifyText = `${userInfo.data.data.name} изменил срок окончания <a target="_blank" class="taskName" href="getCurrentTask/${item._id}">${item.alltask[0].taskName}</a> на ${covertDate}  конца.`
                axios.post('/creatNotifyForTaskInfo/api', {
                    // здесь не проверяем Это задача и подзадача
                    isChild:true,
                    // здесь мы отправляем полное задание
                    task:item,
                    //  // если это подзадача тогда получаем индекс этого подзадачу
                    index,
                     // здесь мы отправляем текст для уведомлений
                    notifyText,
                    // кому нужно отправить этот уведомление мы берём идентификатор этого пользователя
                    notificationRecipientID:item.alltask[0].child[index].performer.workerID,
                    // информация пользователя для отправления уведомлений на электронную почту
                    emailInfo:{
                        // здесь мы отправляем идентификатор пользователя
                        userIdForEmail:item.alltask[0].child[index].performer.workerID,
                        // текст для заголовки
                        subject:"Смена срока окончания задачи",
                        // текст для электронную почту
                        textEmail:`${userInfo.data.data.name} изменил срок окончания <a target="_blank" class="taskName" href="https://xn--h1alceggc.xn--p1ai/editChild/${item._id}/${index}">${item.alltask[0].taskName}</a> на ${covertDate}  конца.`
                    }
                })
                .then(function (response) {
                    console.log(response);
                    socket.emit('getNotifyEmit');
                })
                .catch(function (error) {
                    console.log(error);
                });
              }
            }
          }
  
 


}

    if (item?.alltask[0]?.child[index]) {
        return <>
         <div  className={getDarkModoe.ToggleDarkModeReducer.chekced ? "modalCreatTaskDark" : "modalCreatTask"} style={{flexDirection:"column",height:"80vh",overflow:"auto"}}>
                      <div className="perfomerAndShef">
                          <div>
                            {
                                performer?
                                <PerfomerEdit performerS={performer} setperformerS={setperformer} HandleSetPerfomerId={HandleSetPerfomerId} HandleDeletePerfomerId={HandleDeletePerfomerId}/>
                                :
                                <PerfomerEdit performerS={performer} setperformerS={setperformer} HandleSetPerfomerId={HandleSetPerfomerId} HandleDeletePerfomerId={HandleDeletePerfomerId}/>
                            }
                         
                          </div>
                          <div className="iconSubTaskList">
                          <div style={{margin:"10px"}}> 
                          <div style={{margin:"10px"}}> 
                        {
                            prioritet?
                            <DropdownMobilePioritet  isChild={true} prioritetGet={prioritet} allitemForStatus={item} index={index} update={update} />
                            :
                            <Prioritet setPrioritet={setPrioritet} prioritet={prioritet}/>
                          }
                        </div>
                            
                          
                        


                        <div style={{margin:"10px"}}> 
                        {
                        status?
                        <DropdownMobileStatus  isChild={true} statusGet={status} allitemForStatus={item} index={index} update={update} />
                        :
                        <Status setStatus={setStatus} status={status}/>
                        }
                        </div>
                          </div>



                        <div >

                        </div>

                         </div>
                      </div>
                    <div className="inputCreatTask">
    
                            <div className="taskinputsDiv">
                            <MetkaEdit setMetka={setMetka} metka={metka}/>
                            <p>Имя текущей подзадачи</p>
                            <input className="currentTaskName" value={nameCurrentSubTask} disabled/>
                            <div style={{margin: "30px 0px"}}>
                                      <p className="srok">Сроки</p>
                                      {(() => {
                                                  if (item?.creatorTasks === getmyinfo.myinfo._id) {
                                                    return (
                                                      <div className="date">
                                                      <label htmlFor="">
                                                        {/* Дата начала  для поставщика*/}
                                                        Дата начала:
                                                        <input
                                                          size="sm"
                                                          type="datetime-local"
                                                          colorScheme="grey"
                                                          value={startDate}
                                                          onChange={(e) => setStartDate(e.target.value)}
                                                          
                                                        />
                                                      </label>
                                                      <label htmlFor="">
                                                        {/* Дата окончания  для поставщика*/}
                                                        Дата конца:
                                                        <input
                                                          size="sm"
                                                          type="datetime-local"
                                                          value={endDate}
                                                          onChange={(e) => setEndDate(e.target.value)}
                                                        />
                                                      
                                                      </label>
                                                    </div>
                                                    )
                                                  }else{
                                                    return (
                                                      <div className="date">
                                                      <label htmlFor="">
                                                        {/* Дата начала  для исполнителя*/}
                                                        Дата начала:
                                                        <input
                                                          size="sm"
                                                          type="datetime-local"
                                                          colorScheme="grey"
                                                          value={startDate}
                                                          onChange={(e) => setStartDate(e.target.value)}
                                                          disabled
                                                          
                                                        />
                                                      </label>
                                                      <label htmlFor="">
                                                        {/* Дата окончания  для исполнителя*/}
                                                        Дата конца:
                                                        <input
                                                          size="sm"
                                                          type="datetime-local"
                                                          defaultValue={endDate}
                                                          onChange={(e) => setDndDateConfirm(e.target.value)}
                                                          key={endDate + endDateConfirm + item.endDate}
                                                        />
                                                        <button onClick={handleDate} className="confirmEditDate">Запросить подтверждение</button>
                                                      </label>
                                                    </div>
                                                      )
                                                  }
                                                })()}
                                  </div>
                              <textarea placeholder='Добавьте  описание подзадачи'  className="taskDeskription" value={aboutTask} onChange={(e) => setAboutTask(e.target.value)}/>
                              <p className="taskDeskriptionText">Добавьте описание задачи</p>
        

                        {/* загрузить файл дочернего компонента */}
                              <UploadFileTaskMenegerEditChilds file={file}  handleChangeFile={handleChangeFile}/>
                             
                            
                            </div>

                            <div className="taskinputsDiv2">
                              {/* Компонент исполнителя */}
                          
                                 
                                              
                        {/* компонент состояния */}
                        {/* <StatusEdit setStatus={setStatus} status={status} creatorTasks={allitem.creatorTasks}/> */}
                       
                                       {(() => {
                                                  if (item?.creatorTasks !== getmyinfo.myinfo._id) {
                                                    return (
                                                      <button onClick={handleStatus} className="confirmEditDate">Сдать работу</button> 
                                                    )
                                                  }
                                                })()}   
                          {/* метка компонент */}
                          {
                            comments?
                            <CommentBox setComments={setComments}comments={comments} index={index} isChild={true} allitem={item} editAllTask={item.alltask} update={update}/>
                            :
                            ""
                          }
                         
                            </div>
                          </div>
                    </div>
                    <div className="currentTaskButton">

{
  loadBTN ?
    <button disabled> Загрузка</button>
    :
    <button className="EditSaveBtn" onClick={sendserver}> Сохранить</button>
}
</div>
   
    </>
    }else{
            return <h1 style={{textAlign:"center"}}>подзадача или удалена или не существует</h1>
    }

   
}